import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.baseURL}`

export default {
    async listGroup(params) {
        const response = await Repository.get(`${resource}/indicator-group`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },

    async updateGroup(id, group) {
        const response = await Repository.patch(`${resource}/indicator-group/${id}`, group, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async deleteGroup(id) {
        const response = await Repository.delete(`${resource}/indicator-group/${id}`, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async createGroup(group) {
        const response = await Repository.post(`${resource}/indicator-group`, group, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async create(indicator) {
        const response = await Repository.post(`${resource}/indicator`, indicator, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async update(id, indicator) {
        const response = await Repository.patch(`${resource}/indicator/${id}`, indicator, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async delete(id) {
        const response = await Repository.delete(`${resource}/indicator/${id}`, {
            headers: TokenService.getHeader(),
        })
        return response
    }
}
